import { render, staticRenderFns } from "./AdminActivities.vue?vue&type=template&id=44cb6a57&scoped=true"
import script from "./AdminActivities.vue?vue&type=script&lang=js"
export * from "./AdminActivities.vue?vue&type=script&lang=js"
import style0 from "./AdminActivities.vue?vue&type=style&index=0&id=44cb6a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb6a57",
  null
  
)

export default component.exports